<template>
	<inertia-head title="Transactions Completed" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Transactions Completed</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Completed Transactions</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded shadow mb-1">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-3">
							<div class="form-group mb-4">
								<flat-pickr
									v-model="form.startDate"
									id="startDate"
									class="form-select"
									placeholder="Select start date"
								/>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group mb-4">
								<flat-pickr
									v-model="form.endDate"
									id="endDate"
									class="form-select"
									placeholder="Select end date"
								/>
							</div>
						</div>
						<div class="col space-x-1 mb-4">
							<button type="submit" class="btn btn-alt-primary">
								Refine Result
							</button>
							<button
								@click="$inertia.visit(route('admin.transactions.completed'))"
								type="button"
								class="btn btn-alt-secondary"
							>
								Reset
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table id="checkout_success_table" class="table table-striped table-borderless table-hover table-vcenter">
						<thead>
							<tr>
								<th>#</th>
								<th>TXNID</th>
								<th>NAME</th>
								<th>CONFIRM DATE</th>
								<th>EMAIL</th>
								<th>COURSE</th>
								<th>AMOUNT</th>
								<th>REFERENCE</th>
							</tr>
						</thead>
						<tbody class="fs-sm">
							<tr
								v-for="(transaction, index) in transactions.data"
								:key="transaction.counter"
							>
								<td>{{ index + transactions.from }}</td>
								<td>{{ transaction.txnid }}</td>
								<td>{{ transaction.fullname }}</td>
								<td>{{ transaction.cdate }}</td>
								<td>{{ transaction.email }}</td>
								<td>{{ transaction.course }}</td>
								<td class="text-end">{{ transaction.amount }}</td>
								<td>{{ transaction.mop }}</td>
							</tr>
							<tr v-if="transactions.data.length == 0">
								<td colspan="12" class="text-center">NO DATA FOUND</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination :collections="transactions" />
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'


export default {
	layout: AuthLayout,
	props: {
		transactions: Object,
		filters: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')

			// $("#checkout_success_table").DataTable( {
			// 	dom: 'Bfrtip',
   //              buttons: [
	  //               { extend: 'copy', className: 'btn btn-sm btn-info' },
	  //               { extend: 'csv', className: 'btn btn-sm btn-warning' },
	  //               { extend: 'excel', className: 'btn btn-sm btn-success' },
	  //               { extend: 'pdf', className: 'btn btn-sm btn-primary' },
	  //               { extend: 'print', className: 'btn btn-sm btn-danger' },
   //              ],
			//     "bPaginate": false,
		 //        "bFilter": false,
		 //        "bInfo": false
			// } );
		})

		const form = useForm({
			startDate: props.filters.startDate,
			endDate: props.filters.endDate,
		})

		const submit = () => {
			form.get(route('admin.transactions.completed'), {
				preserveState: true,
				preserveScroll: true,
			})
		}

		return {
			form,
			submit,
		}
	},
}
</script>
